/* Scribble Snacks phone-model picker (Poppy, 29 Sep 2026; Ben: "improve the on-page variant selector design").
   Ben 1 Nov: "smaller and easier to use": the wall of model pills is now one compact pill, a real select that opens the
   phone's own list, grouped by series (newest first, the order of the product's option values).
   It never owns state: every choice checks the theme's native radio (or select) for the "Model" option and fires
   'change', so Dawn's own flow updates price, availability, the add-to-cart variant id and ?variant= in the URL.
   The native Model fieldset is only hidden once this script has run (.ss-pp-on), so the page works without JS.
   Loaded only by templates/product.phone-case.json. Rollback: ops/theme-backups/2026-09-29-phone-picker/. */
(function () {
  'use strict';
  var MIN_VALUES = 7; // fewer than this: the native pills are fine (e.g. AirPods 1 & 2 / 3 / Pro)
  var OPTION_RE = /^(model|phone model|compatible model|device)$/i;
  var uid = 0;

  function brandOf(v) {
    if (/^iphone/i.test(v)) return 'iPhone';
    if (/galaxy|samsung/i.test(v)) return 'Samsung';
    if (/pixel/i.test(v)) return 'Pixel';
    if (/airpods/i.test(v)) return 'AirPods';
    return 'Other';
  }
  function seriesOf(v) {
    var m;
    if ((m = v.match(/^iPhone (\d+)/))) return 'iPhone ' + m[1] + ' series';
    if (/^iPhone Air/.test(v)) return 'iPhone Air';
    if (/^iPhone X/.test(v)) return 'iPhone X, XS & XR';
    if (/^iPhone SE/.test(v)) return 'iPhone SE';
    if ((m = v.match(/^Galaxy (S\d+)/))) return 'Galaxy ' + m[1] + ' series';
    if (/^Galaxy Z Flip/.test(v)) return 'Galaxy Z Flip';
    if (/^Galaxy Z Fold/.test(v)) return 'Galaxy Z Fold';
    if (/^Galaxy A/.test(v)) return 'Galaxy A series';
    if ((m = v.match(/^Pixel (\d+)/))) return 'Pixel ' + m[1] + ' series';
    return brandOf(v);
  }

  function liveSelects(pi) {
    var all = pi.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) if (all[i].style.display !== 'none') return all[i];
    return null;
  }
  // Returns {group, kind:'radio'|'select', values:[{value, available, el}], checked}
  function readNative(pi) {
    var vs = liveSelects(pi);
    if (!vs) return null;
    var groups = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var radios = g.querySelectorAll('input[type="radio"]');
      if (radios.length && OPTION_RE.test((radios[0].dataset.optionName || '').trim())) {
        var vals = [], checked = null;
        radios.forEach(function (r) {
          var unavailable = r.classList.contains('disabled') || r.disabled;
          vals.push({ value: r.value, available: !unavailable, el: r });
          if (r.checked) checked = r.value;
        });
        return { vs: vs, group: g, kind: 'radio', values: vals, checked: checked, position: i };
      }
      var sel = g.querySelector('select');
      if (sel) {
        var lab = g.querySelector('label');
        var name = (sel.name || '').replace(/^options\[|\]$/g, '');
        if (OPTION_RE.test(name.trim()) || (lab && OPTION_RE.test(lab.textContent.trim()))) {
          var v2 = [];
          Array.prototype.forEach.call(sel.options, function (o) { v2.push({ value: o.value, available: !o.disabled && !/unavailable|sold out/i.test(o.textContent.replace(o.value, '')), el: o }); });
          return { vs: vs, group: g, kind: 'select', select: sel, values: v2, checked: sel.value, position: i };
        }
      }
    }
    return null;
  }

  function choose(pi, value) {
    var n = readNative(pi);
    if (!n) return;
    if (n.kind === 'radio') {
      var r = n.values.filter(function (x) { return x.value === value; })[0];
      if (!r || r.el.checked) return;
      r.el.checked = true;
      r.el.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      if (n.select.value === value) return;
      n.select.value = value;
      n.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  function build(pi, n) {
    var id = 'ss-pp-' + (++uid);
    var root = el('div', 'ss-pp', { 'data-ss-phone-picker': '' });
    var label = el('label', 'ss-pp__label', { for: id });
    label.textContent = 'Your phone model';
    root.appendChild(label);
    var field = el('div', 'ss-pp__field');
    var select = el('select', 'ss-pp__select', { id: id });
    var groups = {}, order = [];
    n.values.forEach(function (v) {
      var s = seriesOf(v.value);
      if (!groups[s]) { groups[s] = []; order.push(s); }
      groups[s].push(v.value);
    });
    if (!n.checked) {
      var ph = el('option', '', { value: '', disabled: '', selected: '' });
      ph.textContent = 'Choose your model';
      select.appendChild(ph);
    }
    order.forEach(function (s) {
      var og = el('optgroup', '', { label: s });
      groups[s].forEach(function (val) {
        var o = el('option', '', { value: val });
        o.textContent = val;
        og.appendChild(o);
      });
      select.appendChild(og);
    });
    field.appendChild(select);
    field.appendChild(el('span', 'ss-pp__caret', { 'aria-hidden': 'true' }));
    root.appendChild(field);

    function sync() {
      var nn = readNative(pi);
      if (!nn) return;
      var avail = {};
      nn.values.forEach(function (v) { avail[v.value] = v.available; });
      Array.prototype.forEach.call(select.options, function (o) {
        if (!o.value) return;
        var text = o.value + (avail[o.value] === false ? ' (sold out)' : '');
        if (o.textContent !== text) o.textContent = text; // only on a real change: this list sits inside the observed node
      });
      if (nn.checked && select.value !== nn.checked) select.value = nn.checked;
    }

    select.addEventListener('change', function () { choose(pi, select.value); });

    // Re-sync whenever Dawn swaps the variant-selects (after each option change, incl. other options like colour)
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 60); }).observe(pi, { childList: true, subtree: true });
    root._ssSync = sync;
    sync();
    return root;
  }

  function init(pi) {
    if (!pi || pi.dataset.ssPpInit) return;
    var n = readNative(pi);
    if (!n || n.values.length < MIN_VALUES) return;
    pi.dataset.ssPpInit = '1';
    var root = build(pi, n);
    // Model first in the option list: picker goes above the other options; otherwise below them.
    if (n.position === 0) n.vs.parentNode.insertBefore(root, n.vs);
    else n.vs.parentNode.insertBefore(root, n.vs.nextSibling);
    pi.classList.add('ss-pp-on');
  }

  function initAll() { document.querySelectorAll('product-info').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('product-info:loaded', function (e) { init(e.target.closest ? e.target.closest('product-info') || e.target : e.target); });
})();

